export default __webpack_public_path__ + "static/media/developper.b2d8ee3b.jpg";